import { useState } from 'react';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { NestedTableStateBaseParams, NestedTableState } from '../state';

export function useNestedTable<C extends string>(
  params: NestedTableStateBaseParams<C>,
) {
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new NestedTableState({
        ...params,
        container,
      }),
  );

  return state;
}
